import { useState } from "react";
import { Mail, X } from "lucide-react";
import { customerApi } from "../lib/customerApi";

export function LeadCaptureModal({ open, onClose, onComplete, productId, action }) {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    if (!open) return null;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        if (!email.trim()) {
            setErr("Please enter your email");
            return;
        }
        setBusy(true);
        try {
            await customerApi.post("/lead-intents", {
                email: email.trim().toLowerCase(),
                productId: productId || null,
                action,
            });
            onComplete?.(email.trim().toLowerCase());
            onClose?.();
        } catch (e2) {
            setErr("Could not save your email. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    const skip = () => {
        onComplete?.(null);
        onClose?.();
    };

    return (
        <div
            className="fixed inset-0 z-[60] bg-inkDark/40 flex items-end sm:items-center justify-center p-3"
            onClick={onClose}
            data-testid="lead-capture-modal"
        >
            <div
                className="bg-ivory rounded-2xl shadow-lift border border-inkDark/5 w-full max-w-md overflow-hidden animate-fade-up"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="px-6 pt-6 pb-2 flex items-start justify-between">
                    <div className="flex items-center gap-3">
                        <span className="w-9 h-9 rounded-full bg-skyblue/40 flex items-center justify-center">
                            <Mail size={16} className="text-skyblueDeep" />
                        </span>
                        <div>
                            <span className="label-eyebrow">Atelier note</span>
                            <h3 className="font-display text-2xl text-inkDark leading-tight mt-1">
                                We&rsquo;ll hold this for you
                            </h3>
                        </div>
                    </div>
                    <button onClick={onClose} className="p-1 text-inkMuted hover:text-inkDark" aria-label="Close" data-testid="lead-modal-close">
                        <X size={18} />
                    </button>
                </div>
                <p className="px-6 mt-2 text-inkMuted">
                    Drop your email &mdash; we&rsquo;ll save your pick and ping you on price drops or low stock.
                </p>
                <form onSubmit={submit} className="px-6 pt-5 pb-6">
                    <input
                        type="email"
                        required
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="your@email.com"
                        className="w-full rounded-xl border border-inkDark/10 bg-white px-4 py-3 outline-none focus:border-skyblueDeep"
                        data-testid="lead-modal-email-input"
                    />
                    {err ? <div className="mt-2 text-sm text-red-600">{err}</div> : null}
                    <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
                        <button
                            type="button"
                            onClick={skip}
                            className="text-sm text-inkMuted hover:text-inkDark"
                            data-testid="lead-modal-skip"
                        >
                            Skip for now
                        </button>
                        <button type="submit" disabled={busy} className="btn-pill text-sm disabled:opacity-50" data-testid="lead-modal-submit">
                            {busy ? "Saving…" : "Save my pick"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
